<ng-container *ngIf='data$ | async as data'>
  <youtube-player
    [class]='data.styleClasses'
    [videoId]='data.videoId'
    [playerVars]="{'enablejsapi':1,'controls':0,'modestbranding':1,'playsinline':1,'showinfo':0,'rel':0, 'autoplay': 1, 'loop': 1, 'playlist': data.videoId, 'mute': 1}"
  ></youtube-player>
</ng-container>
